const specs = [
  {
    icon: 'ri-palette-line',
    title: 'Full-Color Print',
    desc: 'Unlimited colour options with vibrant, true-to-design output',
  },
  {
    icon: 'ri-image-2-line',
    title: 'High-Res Graphics',
    desc: 'Crisp, sharp imagery even at large tent scale',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'UV & Waterproof Fabric',
    desc: 'Print stays vivid and protected in any weather',
  },
  {
    icon: 'ri-fire-line',
    title: 'Fire Retardant Certified',
    desc: 'Meets international fire safety standards',
  },
];

export default function FabricSpecs() {
  return (
    <section className="py-16 bg-white border-t border-gray-100">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl font-bold text-gray-900 text-center mb-10">
          Premium Print Quality. Professional Fabric.
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {specs.map((s, i) => (
            <div
              key={i}
              className="bg-gray-50 rounded-xl p-6 text-center hover:scale-105 transition-transform duration-300 cursor-default"
            >
              <div className="w-14 h-14 mx-auto mb-4 bg-teal-50 rounded-xl flex items-center justify-center">
                <i className={`${s.icon} text-3xl text-teal-400`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-1">{s.title}</h3>
              <p className="text-xs text-gray-500 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
